import axios from 'axios'
import Md5 from "js-md5";

let getValidData = function() {
  let key = "!#nongwebsite@1234567890QwErTyUiOpMAll*$&";
  let data,token,timestamp;
  timestamp = new Date().valueOf();
  token = Md5(Md5(key + '_' + timestamp));
  data = {
    token: token,
    timestamp: timestamp
  };
  return data
};

// create an axios instance
const service = axios.create({
  // baseURL:'http://115.159.43.117:8080/nong-website-api',
  baseURL:'http://www.nong-studio.com:80/nong-website-api/',
  headers:getValidData(),
  // baseURL:'/api',
  // 'http://212.129.152.24:80/sk-website-api',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject("网络异常");
    }
  },
  error => {
    return Promise.reject(error + "");
  }
);

export default service
